import React from 'react';
import Iso from 'iso';
import Raven from 'raven-js';
import * as Render from 'alt/utils/Render';

import Router from 'react-router';

import routes from './routes';
import alt from './alt';
import seo from './seo';
import logger from './logger';
import {i18n} from './i18n';

import CurrentUserStore from './stores/CurrentUserStore';


// Register to SEO store changes
seo();

// Raven stuff
if (DJ_CONST.RAVEN_PUBLIC_DSN) {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
}

// Run AltIso
Iso.on('iso', 1, function(state, meta, container) {
    alt.bootstrap(state);

    // Ensure that we have the current user (if any) before starting routing, because routing depends on whether the
    //  user is authenticated.
    CurrentUserStore.getCurrentUser().then(() => {
        // Set correct language
        const activeLanguage = CurrentUserStore.getState().activeLanguage;
        logger.debug(`Set language to: ${activeLanguage}`);
        i18n.forceLanguage(activeLanguage);

        Router.run(routes, Router.HistoryLocation, (Handler, props) => {
            props.buffer = new Render.DispatchBuffer();
            React.render(<Handler {...props} />, container);
        });
    });
});



/** WEBPACK FOOTER **
 ** ./app/src/client.js
 **/